import { render } from "./CreateSaleModal.vue?vue&type=template&id=4bac66bc&scoped=true"
import script from "./CreateSaleModal.vue?vue&type=script&lang=js"
export * from "./CreateSaleModal.vue?vue&type=script&lang=js"

import "./CreateSaleModal.vue?vue&type=style&index=0&id=4bac66bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bac66bc"]])

export default __exports__